import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink, useParams } from 'react-router-dom';
import { LinkContext } from "../../../contexts/layouts/LinkContext";
import ProjectContext from "../../../contexts/data/ProjectContext";
import StageContext from "../../../contexts/data/StageContext";
import StagesContext from "../../../contexts/data/StagesContext";

const StyledDivider = styled(Divider)(() => ({
    margin: `0 !important`
}));

const NavigationStageSelector: FC = () => {
    const params = useParams();

    const stageId = Number(params.stageId);

    const { createProjectLink, createStageLink, stageLinkEnabled } = useContext(LinkContext);
    
    const { data: project} = useContext(ProjectContext);
    const { data: stage } = useContext(StageContext);
    const { data: stages } = useContext(StagesContext);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {
        if (!project) {
            return undefined;
        }
        
        return stages?.map((x, i, a) => {
            return (
                [
                    <MenuItem 
                        key={x.id} 
                        component={RouteLink} 
                        to={createStageLink(project, x)} 
                        onClick={handleClose}
                    >
                        {x.name}
                    </MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.name}-divider`} /> : null
                ]
            );
        })
    }, [stages, project, createStageLink, handleClose])

    if (!stageLinkEnabled || !project) {
        return null;
    }
    
    return (
        <>
            <Button
                id="btn-stages"
                color="primary"
                aria-label="stage selection"
                aria-controls="menu-stages"
                aria-haspopup="true"
                sx={{mr: 2}}
                onClick={handleMenu}
                endIcon={<FontAwesomeIcon icon={faChevronDown} style={{fontSize: '1rem'}} fixedWidth />}
            >
                {
                    stageId && stage ?
                        stage.name :
                        'No Stage Selected'
                }
            </Button>
            <Menu
                id="menu-stages"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={anchorEl?.id === 'btn-stages'}
                onClose={handleClose}
                slotProps={{
                    list: {
                        disablePadding: true
                    }
                }}
            >
                <MenuItem component={RouteLink} to={createProjectLink(project)} onClick={handleClose}>All Stages</MenuItem>
                <StyledDivider />
                {list}
            </Menu>
        </>
    )
}

export default NavigationStageSelector;